import React from 'react';
import { useQuery, useMutation, queryCache } from 'react-query';
import BernExpoTicket from '../components/BernExpoTicket';
import ParkingTicketBody from '../components/ParkingTicketBody';
import Header from '../components/ExternalPage/Header';
import DeviceStoreButtons from '../components/eTicket/DeviceStoreButtons';
import Loader from '../components/Loader';
import ErrorMessages from '../components/ErrorMessages';
import requsetErrorMessage from '../libraries/requsetErrorMessage';
import parkingSliderWindow from '../libraries/parkingSliderWindow';
import parkingFieldColor from '../libraries/parkingFieldColor';
import api from '../api';
import ErrorIcon from '../assets/images/icons/error.png';

/**
 * Public parking eticket page (shared link). Mirrors the regular eTicket page
 * but renders a parking card: QR (server-rendered image) + field/game details.
 * @component
 */
export default ({ match }) => {
  const { data, error, isLoading } = useQuery(
    ['parking-eticket', match.params.token],
    api.parking.eTicket,
  );
  const ticket = data?.data;

  // Recipient marks the shared card used via slide-to-confirm (non-BernExpo
  // fields have no gate scanner) — a link recipient must also be swiped in.
  const [markUsed, { isLoading: isMarking }] = useMutation(api.parking.usePublic, {
    onSuccess() {
      queryCache.invalidateQueries(['parking-eticket', match.params.token]);
    },
  });

  const canConfirm =
    !!ticket && !ticket.used_at && !ticket.uses_external_qr && parkingSliderWindow(ticket.game_date);
  const mapsUrl =
    ticket && ticket.field_latitude != null && ticket.field_longitude != null
      ? `https://www.google.com/maps/search/?api=1&query=${ticket.field_latitude},${ticket.field_longitude}`
      : null;

  return (
    <div className="external-page">
      <Header />

      {!!error?.data?.message && (
        <center>
          <img src={ErrorIcon} alt="error" style={{ marginTop: 50, width: 60 }} />

          <ErrorMessages messages={requsetErrorMessage(error.data.message)} />
        </center>
      )}

      {isLoading ? (
        <Loader style={{ marginTop: 100 }} />
      ) : !ticket ? null : ticket.uses_external_qr ? (
        // BernExpo: distinct fully-digital QR design (no slider).
        <div className="ticket-view">
          <BernExpoTicket
            qrImage={ticket.qr_image}
            opponent={ticket.game_opponent}
            gameDate={ticket.game_date}
            usedAt={ticket.used_at}
          />

          <div
            className="no-print"
            style={{ display: 'flex', justifyContent: 'center', margin: '4px 0 10px' }}
          >
            <button
              onClick={() => window.print()}
              style={{
                background: '#e73c37',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '10px 24px',
                fontSize: 15,
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              Parkkarte drucken
            </button>
          </div>

          <h3
            className="no-print"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <DeviceStoreButtons />
          </h3>
        </div>
      ) : (
        <div className="ticket-view">
          <ParkingTicketBody
            qrImage={ticket.qr_image}
            qrPayload={ticket.qr_payload}
            usedAt={ticket.used_at}
            color={parkingFieldColor(ticket.field_slug)}
            fieldName={ticket.field_name}
            entrance={ticket.field_entrance}
            mapsUrl={mapsUrl}
            infoText={ticket.field_info_text}
            opponent={ticket.game_opponent}
            gameDate={ticket.game_date}
            location="PostFinance Arena"
            canConfirm={canConfirm}
            confirming={isMarking}
            onConfirm={() => markUsed(match.params.token)}
          />

          <h3
            className="no-print"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <DeviceStoreButtons />
          </h3>
        </div>
      )}
    </div>
  );
};
